// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__QLRHh","plus":"styles_plus__V3Lqv","key":"styles_key__b33w2"};